import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRobot,
  faComments,
  faFilePdf,
  faWandMagicSparkles,
  faGears,
  faFileLines,
  faEnvelopeOpenText,
  faGlobe,
  faUserGear,
  faFileInvoiceDollar,
  faCartShopping
} from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);

  const toRotate = [
    "building AI-powered web applications",
    "building automation-driven SaaS products",
    "building scalable full-stack systems",
    "building LLM-integrated products",
    "building custom business automation solutions"
  ];

  const period = 3000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);
    return () => clearInterval(ticker);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) setDelta((prevDelta) => prevDelta / 2);

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  // White, border-only chip style (no background)
  const chipStyle = {
    border: "1px solid rgba(255,255,255,0.65)",
    color: "rgba(255,255,255,0.95)",
    padding: "6px 12px",
    borderRadius: "9999px",
    fontSize: "0.875rem",
    background: "transparent"
  };

  return (
    <Router>
      <section className="banner" id="home">
        <Container>
          {/* HERO */}
          <Row className="align-items-center">
            <Col xs={12} md={6} xl={7}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                    <span className="tagline">Welcome to my Portfolio</span>

                    <h1 className="hero-title">
                      Hi! I'm <span className="text-gradient">Mohit Arora</span>
                    </h1>

                    <h2 className="hero-typed">
                      <span className="txt-rotate">
                        <span className="wrap">{text}</span>
                      </span>
                    </h2>


                    <p>
                      I’m an experienced <strong>Software Developer, DevOps Engineer, and AI Engineer</strong> with
                      over <strong>2.5 years of hands-on experience</strong> building
                      <strong> LLM-powered products</strong> and <strong>AI-driven platforms</strong>.
                      My core expertise lies in <strong>AI automation</strong>, <strong>large language model integration</strong>,
                      <strong> resume parsing</strong>, <strong>ATS optimization</strong>,
                      <strong> scalable e-commerce systems</strong>, and
                      <strong> cloud-native deployments with DevOps pipelines</strong>.
                    </p>


                    <HashLink to="#connect" style={{ textDecoration: "none" }}>
                      <button className="connect-button primary">
                        Discuss Your Project <ArrowRightCircle size={22} />
                      </button>
                    </HashLink>

                  </div>
                )}
              </TrackVisibility>
            </Col>

            <Col xs={12} md={6} xl={5}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={headerImg} alt="Header Img" />
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>

          {/* WHAT I'M DOING NOW */}
          <Row className="align-items-center mt-5">
            {/* Left: Copy */}
            <Col xs={12} md={7} xl={7}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__fadeInLeft" : ""}>

                    <h2 className="mb-3">What I’m Building for Clients</h2>

                    <p className="mb-3">
                      Right now, I’m focused on <strong>building practical, AI-powered solutions</strong>
                      that help businesses <strong>automate operations</strong>, reduce manual effort,
                      and launch <strong>scalable SaaS products</strong>. My current work revolves around
                      systems that combine <strong>AI automation</strong>, <strong>clean UX</strong>, and
                      <strong> production-ready engineering</strong>.
                    </p>

                    <p className="mb-3">
                      This includes platforms like <strong>AI-driven interview and hiring systems</strong>,
                      <strong> resume & cover letter automation</strong>, <strong>1-click personal and business websites</strong>,
                      and <strong>advanced PDF processing pipelines</strong> using LLMs for structured data
                      extraction and accessibility-ready outputs.
                    </p>

                    <div className="d-flex flex-wrap gap-2 mb-2">
                      <span style={chipStyle}>AI Hiring Systems</span>
                      <span style={chipStyle}>Business Automation</span>
                      <span style={chipStyle}>SaaS Platforms</span>
                      <span style={chipStyle}>LLM Integrations</span>
                      <span style={chipStyle}>PDF & Data Pipelines</span>
                      <span style={chipStyle}>Admin Dashboards</span>
                      <span style={chipStyle}>Cloud & DevOps</span>
                      <span style={chipStyle}>E-commerce</span>
                      <span style={chipStyle}>Banking / Loan Systems</span>
                      <span style={chipStyle}>Real Estate Platforms</span>
                    </div>

                  </div>
                )}
              </TrackVisibility>
            </Col>

            {/* Right: Feature Panel */}
            <Col xs={12} md={5} xl={5} className="mt-4 mt-md-0">
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <div
                      className="p-4 rounded-4 shadow-lg"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(13,202,240,0.12) 0%, rgba(13,110,253,0.08) 100%)",
                        backdropFilter: "blur(6px)"
                      }}
                    >
                      <div className="text-center mb-3 fw-semibold">
                        Solutions I’m Actively Delivering
                      </div>

                      <div
                        className="d-grid"
                        style={{ gridTemplateColumns: "repeat(3, 1fr)", gap: "18px" }}
                      >
                        <div className="text-center">
                          <FontAwesomeIcon icon={faRobot} size="2x" />
                          <div className="small mt-2">AI Automation</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faComments} size="2x" />
                          <div className="small mt-2">Interview Platforms</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faFileLines} size="2x" />
                          <div className="small mt-2">Resume Automation</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faEnvelopeOpenText} size="2x" />
                          <div className="small mt-2">Cover Letters</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faGlobe} size="2x" />
                          <div className="small mt-2">Web Platforms</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faUserGear} size="2x" />
                          <div className="small mt-2">Workflow Automation</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faFilePdf} size="2x" />
                          <div className="small mt-2">PDF Intelligence</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faFileInvoiceDollar} size="2x" />
                          <div className="small mt-2">Loan Systems</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faCartShopping} size="2x" />
                          <div className="small mt-2">E-commerce</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faGears} size="2x" />
                          <div className="small mt-2">DevOps Pipelines</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faGlobe} size="2x" />
                          <div className="small mt-2">Real Estate</div>
                        </div>
                        <div className="text-center">
                          <FontAwesomeIcon icon={faUserGear} size="2x" />
                          <div className="small mt-2">Client Projects</div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>

          {/* Reserved for future content */}
          <Row className="align-items-center mt-5"></Row>
        </Container>
      </section>
    </Router>
  );
};
